/**
 * Resolve a safe user-facing message from ajax/axios failures.
 * Never returns HTML, stack dumps, or empty strings.
 */

const GENERIC_AJAX_ERROR =
    'Houve um erro ao tentar executar o serviço! Verifique os detalhes no log desta página.';

function isNonEmptyString(value) {
    return typeof value === 'string' && value.trim().length > 0;
}

function looksLikeHtml(value) {
    return /<\/?[a-z][\s\S]*>/i.test(value);
}

function looksLikeStack(value) {
    return /(^|\n)\s*at\s+\S+/m.test(value) && value.includes('\n');
}

function sanitizeMessage(value) {
    if (!isNonEmptyString(value)) {
        return null;
    }

    let text = value.trim();

    if (looksLikeHtml(text)) {
        text = text.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    }

    if (!text || looksLikeStack(text)) {
        return null;
    }

    // Ignore sentinel first-arg used by legacy ajaxSetError('error', message)
    if (text === 'error') {
        return null;
    }

    if (text.length > 500) {
        text = text.slice(0, 500) + '…';
    }

    return text;
}

function messageFromResponseData(data) {
    if (data == null) {
        return null;
    }

    if (typeof data === 'string') {
        return sanitizeMessage(data);
    }

    if (typeof data === 'object') {
        return sanitizeMessage(data.message);
    }

    return null;
}

/**
 * @param {*} error First argument (Error, Axios error, or legacy string message)
 * @param {string|null|undefined} explicitMessage Second argument when provided
 * @returns {string}
 */
function resolveAjaxErrorMessage(error, explicitMessage) {
    const fromExplicit = sanitizeMessage(explicitMessage);
    if (fromExplicit) {
        return fromExplicit;
    }

    if (typeof error === 'string') {
        const fromString = sanitizeMessage(error);
        if (fromString) {
            return fromString;
        }
    }

    try {
        const fromResponse = messageFromResponseData(
            error && error.response ? error.response.data : null
        );
        if (fromResponse) {
            return fromResponse;
        }
    } catch (e) {
        // ignore malformed response shapes
    }

    if (error && typeof error.message === 'string') {
        const fromError = sanitizeMessage(error.message);
        if (fromError) {
            return fromError;
        }
    }

    return GENERIC_AJAX_ERROR;
}

module.exports = {
    GENERIC_AJAX_ERROR,
    sanitizeMessage,
    resolveAjaxErrorMessage,
};
